module.exports = "// Pseudo-code\nclass WithLocalization extends Component {\n  componentDidMount () {\n    // Fetch user data from Api, localStorage, whatever\n    // Then call setState({ localization })\n  }\n\n  render () {\n    const { localization } = this.state\n    const { children } = this.props\n\n    return localization\n      ? children(localization)\n      : null\n  }\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/function-children-example-2.js
 ** module id = 371
 ** module chunks = 0
 **/